/**
 * Discover back: prefer same-origin history when available; else follow href fallback.
 * Targets [data-discover-back] (desktop floating library back).
 */
(function () {
  function hasSameOriginReferrer() {
    if (!document.referrer) return false;
    try {
      return new URL(document.referrer).origin === window.location.origin;
    } catch (e) {
      return false;
    }
  }

  function canUseHistoryBack() {
    return hasSameOriginReferrer() || window.history.length > 1;
  }

  function onBackClick(event) {
    var link = event.target.closest('[data-discover-back]');
    if (!link || event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    if (!canUseHistoryBack()) return;

    event.preventDefault();
    window.history.back();
  }

  document.addEventListener('click', onBackClick);
})();
